import { useEffect, useRef, useState } from "react";
import { AmbientAudio } from "@/hero/audio";
import { FlightCanvas } from "@/components/FlightCanvas";
import { SpaceCopy } from "@/components/SpaceCopy";
import { HeroCopy } from "@/components/HeroCopy";
import { Nav } from "@/components/Nav";
import { Loader } from "@/components/Loader";

const prefersReduced = () => window.matchMedia("(prefers-reduced-motion: reduce)").matches;

export default function Hero() {
  const trackRef = useRef(null);
  const audioRef = useRef(null);
  const [reduced, setReduced] = useState(prefersReduced);
  const [ready, setReady] = useState(false);
  const [loadFrac, setLoadFrac] = useState(0.04);
  const [audioOn, setAudioOn] = useState(false);

  useEffect(() => {
    audioRef.current = new AmbientAudio();
    return () => audioRef.current?.dispose();
  }, []);

  useEffect(() => {
    const mq = window.matchMedia("(prefers-reduced-motion: reduce)");
    const fn = (e) => setReduced(e.matches);
    mq.addEventListener("change", fn);
    return () => mq.removeEventListener("change", fn);
  }, []);

  useEffect(() => {
    const q = new URLSearchParams(window.location.search).get("p");
    if (!q) return;
    const el = trackRef.current;
    if (!el) return;
    const t = setTimeout(() => {
      const range = el.offsetHeight - window.innerHeight;
      window.scrollTo(0, Math.min(parseFloat(q) || 0, 1) * range);
    }, 300);
    return () => clearTimeout(t);
  }, []);

  const toggleAudio = () => setAudioOn(!!audioRef.current?.toggle());

  return (
    <div ref={trackRef} id="top" data-testid="hero-scroll-track" className="relative h-[640vh]">
      <section data-testid="hero-section" className="sticky top-0 h-[100svh] w-full overflow-hidden bg-[#070A0F]">
        <FlightCanvas trackRef={trackRef} reduced={reduced} onReady={() => setReady(true)} onLoad={setLoadFrac} audioRef={audioRef} />
        <div className="scrim-space pointer-events-none absolute inset-0 z-10" />
        <Nav audioOn={audioOn} onToggleAudio={toggleAudio} />
        <SpaceCopy trackRef={trackRef} reduced={reduced} />
        <HeroCopy trackRef={trackRef} reduced={reduced} onToggleMotion={() => setReduced((v) => !v)} />
        <Loader progress={loadFrac} done={ready} />
      </section>
    </div>
  );
}
